'use strict'
// -> Components
import Header from './components/header'
import SetTheme from './components/set-theme'
import SetFontSize from './components/set-font-size'
import Slider from './components/slider'
import Hero from './components/hero'
import EsgCocal from './components/esg_cocal'
import EsgPillars from './components/esg_pillars'
import News from './components/news'
import MoreNews from './components/more-news'
import Report from './components/report'
import AdviceSlider from './components/advice_slider'
import Numbers from './components/numbers_cocal'
import Partners from './components/our_partners'
import Reference from './components/reference'
import Timeline from './components/timeline'
import CarouselDescriptive from './components/carousel_descriptive'
import CollapseBlocks from './components/collapse_blocks'
import Testimonials from './components/testimonials'
import StepByStep from './components/step-by-step'
import ListOfPost from './components/list-of-posts'
import ModalGallery from './partials/modal-gallery'
import Contact from './pages/contact'
import Forms from './partials/forms'
import Essence from './components/essence'
import Investors from './components/investors'
import Anchors from './components/anchors_fixed'
import TabList from './components/tab_list'
import GoTop from './components/go_top'
import Newsletter from './components/newsletter'


// -> Content News
// import StepByStep- from './components/step-by-step'

export default class App {
  constructor() {
    // # Declare an Element for each class
    // -> Components
    const HeaderElement = document.querySelector('.header-main')
    const SetThemeElement = document.querySelector('body')
    const SetFontSizeElement = document.querySelector('body')
    const SliderElement = document.querySelector('.slider-component')
    const HeroElement = document.querySelector('[data-component="hero"]')
    const EsgCocalElement = document.querySelector(
      '[data-component="esg_cocal"]'
    )
    const EsgPillarsElement = document.querySelector('.esg-pillars-component')
    const NewsElement = document.querySelector('.news-slider')
    const MoreNewsElement = document.querySelector('.more-news-slider')
    const ReportElement = document.querySelector('.report')
    const AdviceSliderElement = document.querySelector('.advice_slider')
    const NumbersElement = document.querySelector('.numbers-slider')
    const PartnersElement = document.querySelector('.partners-slider')
    const ReferenceElement = document.querySelector('.reference-slider')
    const TimelineElement = document.querySelector('.timeline-slider')
    const CarouselDescriptiveElement = document.querySelector(
      '.descriptive-slider'
    )
    const CollapseBlocksElement = document.querySelector('.accordion')
    const TestimonialsElement = document.querySelector('.testimonials-slider')
    const StepByStepElement = document.querySelector('.steps-slider')
    const ListOfPostElement = document.querySelector('.list-of-posts')
    const ModalGalleryElement = document.querySelector('.modal-gallery')
    const PageContact = document.querySelector('.contact-page')
    const ContactRiElement = document.querySelector('.contact-ri')
    const EssenceElement = document.querySelector('[data-video]')
    const InvestorsElement = document.querySelector('.investors')
    const AnchorsElement = document.querySelector('.anchors_fixed')
    const TabListElement = document.querySelector('.tab-list')
    const GoTopElement = document.querySelector('.go_top')
    const NewsletterElement = document.querySelector('.newsletter')


    // -> Content News
    // const StepByStep-Element = document.querySelector('.steps-slider')

    // # Test if Element exists to load corresponding classes
    // -> Components
    HeaderElement ? new Header() : null
    SetThemeElement ? new SetTheme() : null
    SetFontSizeElement ? new SetFontSize() : null
    SliderElement ? new Slider() : null
    HeroElement ? new Hero() : null
    EsgCocalElement ? new EsgCocal() : null
    EsgPillarsElement ? new EsgPillars() : null
    NewsElement ? new News() : null
    MoreNewsElement ? new MoreNews() : null
    ReportElement ? new Report() : null
    AdviceSliderElement ? new AdviceSlider() : null
    NumbersElement ? new Numbers() : null
    PartnersElement ? new Partners() : null
    ReferenceElement ? new Reference() : null
    TimelineElement ? new Timeline() : null
    CarouselDescriptiveElement ? new CarouselDescriptive() : null
    CollapseBlocksElement ? new CollapseBlocks() : null
    TestimonialsElement ? new Testimonials() : null
    StepByStepElement ? new StepByStep() : null
    ListOfPostElement ? new ListOfPost() : null
    ModalGalleryElement ? new ModalGallery() : null
    PageContact ? new Contact() : null
    PageContact ? new Forms() : null
    ContactRiElement ? new Contact() : null
    EssenceElement ? new Essence() : null
    InvestorsElement ? new Investors() : null
    TabListElement ? new TabList() : null
    AnchorsElement ? new Anchors() : null
    GoTopElement ? new GoTop() : null
    NewsletterElement ? new Newsletter() : null


    // -> Content News
    // StepByStep-Element ? new StepByStep-() : null
  }
}

new App()